var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganizationAccountSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2912 12.3523C32.3425 12.3565 32.3894 12.3651 32.4364 12.3779C32.4364 12.3694 32.4364 12.3608 32.4407 12.3523H32.2912ZM13.1281 12.3523V12.3565C13.1281 12.3651 13.1324 12.3694 13.1324 12.3779C13.1794 12.3651 13.2263 12.3565 13.2733 12.3523H13.1281Z",
    stroke: "url(#paint0_linear_1_364)",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4236 9.13501C32.257 9.17347 32.082 9.19483 31.9026 9.19483C30.6601 9.19483 29.6567 8.1865 29.6567 6.94745C29.6567 6.1442 30.0709 5.44349 30.7028 5.04614C30.0922 4.20444 29.3578 3.46956 28.5167 2.85858C28.491 2.84149 28.4697 2.82012 28.4441 2.80731C28.0512 3.46101 27.3339 3.89682 26.5184 3.89682C25.2758 3.89682 24.2681 2.88849 24.2681 1.64516C24.2681 1.46571 24.2895 1.29054 24.3322 1.12391C23.8284 1.03845 23.3074 1 22.7822 1C22.2485 1 21.719 1.04273 21.2109 1.12818C21.2494 1.29481 21.2664 1.46571 21.2664 1.64516C21.2664 2.88849 20.263 3.89682 19.0205 3.89682C18.2092 3.89682 17.4962 3.46529 17.1033 2.82012C17.0863 2.82867 17.0777 2.83721 17.0606 2.84576C16.2195 3.45674 15.4722 4.20017 14.8659 5.04187C15.4936 5.43922 15.912 6.1442 15.912 6.94745C15.912 8.1865 14.9086 9.19483 13.6661 9.19483C13.4825 9.19483 13.3074 9.17347 13.1409 9.13501C13.047 9.66909 13 10.2203 13 10.7885C13 11.3226 13.047 11.8438 13.1281 12.3565H13.2733C13.4014 12.3309 13.5337 12.3181 13.6661 12.3181C13.8027 12.3181 13.9351 12.3309 14.0632 12.3565C15.1178 12.5403 15.912 13.4589 15.912 14.5655C15.912 15.3773 15.4808 16.0951 14.8318 16.4881C14.8446 16.5052 14.8531 16.5181 14.8659 16.5351C15.4851 17.3854 16.2365 18.1331 17.0863 18.7441C17.4791 18.0861 18.2007 17.646 19.0205 17.646C20.263 17.646 21.2664 18.6543 21.2664 19.8934C21.2664 20.0857 21.2451 20.2694 21.1981 20.4446C21.2237 20.4531 21.2494 20.4531 21.2707 20.4574C21.7617 20.5343 22.2699 20.5727 22.7822 20.5727C23.3117 20.5727 23.8326 20.5343 24.3365 20.4531C24.2938 20.2737 24.2681 20.0857 24.2681 19.8934C24.2681 18.6543 25.2758 17.646 26.5184 17.646C27.3467 17.646 28.0683 18.0946 28.4569 18.7569C28.4825 18.7441 28.5038 18.727 28.5295 18.7099C29.3749 18.0904 30.1221 17.3384 30.7284 16.4881C30.088 16.0908 29.6567 15.3773 29.6567 14.5655C29.6567 13.4589 30.4509 12.5403 31.5056 12.3565C31.6336 12.3309 31.766 12.3181 31.9026 12.3181C32.035 12.3181 32.1631 12.3309 32.2912 12.3565H32.4406C32.4406 12.3437 32.4406 12.3309 32.4449 12.3224C32.5218 11.8225 32.5645 11.3098 32.5645 10.7885C32.5645 10.2245 32.5175 9.66909 32.4236 9.13501ZM26.7489 11.4208C26.719 11.596 26.6849 11.7627 26.6336 11.925C26.5098 12.3523 26.3134 12.7496 26.0658 13.1043C25.8138 13.4674 25.4979 13.7836 25.1392 14.0442C24.6524 14.3988 24.0845 14.6467 23.4611 14.7535C23.2434 14.7919 23.0128 14.8133 22.778 14.8133C22.5687 14.8133 22.3595 14.7962 22.1588 14.7663C21.5269 14.668 20.9505 14.4245 20.4552 14.0699C20.0965 13.8178 19.7848 13.5059 19.5286 13.1512C19.2639 12.7838 19.0547 12.3694 18.9266 11.925C18.8796 11.7627 18.8412 11.6046 18.8155 11.4379C18.7814 11.2286 18.7643 11.0107 18.7643 10.7928C18.7643 10.5535 18.7814 10.3271 18.8241 10.1006C18.9308 9.49391 19.1699 8.9342 19.5158 8.4514C19.7677 8.10105 20.0794 7.78487 20.4338 7.52852C20.9291 7.17389 21.5056 6.92608 22.1289 6.82354C22.3424 6.78509 22.5602 6.77227 22.7822 6.77227C23 6.77227 23.2178 6.78936 23.427 6.82354C24.0589 6.92608 24.6396 7.17389 25.1392 7.53279C25.4893 7.78915 25.801 8.10105 26.0529 8.45567C26.3945 8.9342 26.6336 9.48964 26.7404 10.0921C26.7788 10.3228 26.8002 10.5535 26.8002 10.7928C26.8002 11.0021 26.7831 11.2115 26.7489 11.4208Z",
    stroke: "url(#paint1_linear_1_364)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.867 42.3922C24.632 42.3922 26.0628 40.9614 26.0628 39.1964C26.0628 37.4315 24.632 36.0007 22.867 36.0007C21.1021 36.0007 19.6713 37.4315 19.6713 39.1964C19.6713 40.9614 21.1021 42.3922 22.867 42.3922Z",
    stroke: "url(#paint2_linear_1_364)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8042 30.782C43.5691 30.782 44.9999 29.3512 44.9999 27.5862C44.9999 25.8213 43.5691 24.3905 41.8042 24.3905C40.0392 24.3905 38.6084 25.8213 38.6084 27.5862C38.6084 29.3512 40.0392 30.782 41.8042 30.782Z",
    stroke: "url(#paint3_linear_1_364)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19577 30.782C5.96075 30.782 7.39154 29.3512 7.39154 27.5862C7.39154 25.8213 5.96075 24.3905 4.19577 24.3905C2.43079 24.3905 1 25.8213 1 27.5862C1 29.3512 2.43079 30.782 4.19577 30.782Z",
    stroke: "url(#paint4_linear_1_364)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.867 36.0007V20.7531",
    stroke: "url(#paint5_linear_1_364)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8364 27.5862H28.1712H7.25385",
    stroke: "url(#paint6_linear_1_364)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8456 42.3922C13.6106 42.3922 15.0414 40.9614 15.0414 39.1964C15.0414 37.4315 13.6106 36.0007 11.8456 36.0007C10.0806 36.0007 8.64984 37.4315 8.64984 39.1964C8.64984 40.9614 10.0806 42.3922 11.8456 42.3922Z",
    stroke: "url(#paint7_linear_1_364)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.159 42.3922C35.924 42.3922 37.3548 40.9614 37.3548 39.1964C37.3548 37.4315 35.924 36.0007 34.159 36.0007C32.3941 36.0007 30.9633 37.4315 30.9633 39.1964C30.9633 40.9614 32.3941 42.3922 34.159 42.3922Z",
    stroke: "url(#paint8_linear_1_364)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.159 36.0007V32.9094C34.159 32.6292 33.9311 32.4013 33.6509 32.4013H28.7694C28.4893 32.4013 28.2614 32.1733 28.2614 31.8932V27.5862",
    stroke: "url(#paint9_linear_1_364)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8456 36.0007V32.9094C11.8456 32.6292 12.0736 32.4013 12.3537 32.4013H17.2352C17.5154 32.4013 17.7433 32.1733 17.7433 31.8932V27.5862",
    stroke: "url(#paint10_linear_1_364)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_364",
    x1: 11.9878,
    y1: 12.3722,
    x2: 12.5932,
    y2: 15.9507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_364",
    x1: -5.5,
    y1: 16,
    x2: 50,
    y2: 15.9934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_364",
    x1: -5,
    y1: 42,
    x2: 48.5,
    y2: 41.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_364",
    x1: -5,
    y1: 32,
    x2: 47.5,
    y2: 31.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_364",
    x1: -4.5,
    y1: 33.5,
    x2: 48.5,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_364",
    x1: -9,
    y1: 26.5,
    x2: 47,
    y2: 26.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_364",
    x1: -3.5,
    y1: 23.5,
    x2: 48.5,
    y2: 23.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_364",
    x1: -4,
    y1: 37.5,
    x2: 49,
    y2: 37.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_364",
    x1: -3.5,
    y1: 36.5,
    x2: 49.5,
    y2: 36.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_364",
    x1: -4,
    y1: 36.5,
    x2: 42.3905,
    y2: 53.3352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_364",
    x1: -3.01688,
    y1: 35.5367,
    x2: 43.8421,
    y2: 52.5052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6172D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ADEDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationAccountSettings);
export default __webpack_public_path__ + "static/media/OrganizationAccountSettings.f409db5c92758135ca407432a9cd3b47.svg";
export { ForwardRef as ReactComponent };